import { useState } from 'react'

import { F0Button } from '@factorialco/f0-react'
import { PurchaseDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import PaymentGateway from 'modules/billing/components/PaymentGateway'
import { SimpleChargebeeSubscription, getPlainSelectedPlan } from 'modules/billing/lib/prices'

type SubscribedFrom = 'hub' | 'custom_hub' | 'personalised_hub' | 'starter_plan' | 'f25_plan'

const getButtonLabel = (subscribedFrom: SubscribedFrom) => {
  if (subscribedFrom === 'f25_plan') {
    return i18n.t('pricing_plans.submit')
  }
  return i18n.t('pricing_plans.submit_button.no_plan')
}

type Props = {
  planConfig: SimpleChargebeeSubscription[]
  subscribedFrom: SubscribedFrom
  disabled?: boolean
}

const BillingInfoButton = ({ planConfig, subscribedFrom, disabled = false }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { data: billingData } = useQuery(PurchaseDocument)

  const handleClick = async () => {
    setIsModalOpen(true)
    track(trackingEvents.billing.upgradePlanStart, {
      selected_plans: getPlainSelectedPlan(planConfig),
      subscribed_from: subscribedFrom,
    })
  }

  const isF25Pricing = subscribedFrom === 'f25_plan'
  const customLabel = getButtonLabel(subscribedFrom)
  const buttonType = isF25Pricing ? 'default' : 'promote'
  const canPurchaseSubscription =
    billingData?.billing._policies.subscriptionPurchaseSubscription.can

  return (
    <>
      <F0Button
        disabled={disabled || !canPurchaseSubscription}
        variant={buttonType}
        onClick={handleClick}
        label={customLabel}
      />
      {isModalOpen && (
        <PaymentGateway
          planConfig={planConfig}
          onClose={() => setIsModalOpen(false)}
          isF25Pricing={isF25Pricing}
        />
      )}
    </>
  )
}

export default BillingInfoButton
